<template>
	<v-chip :outlined="outlined" label>
		<v-icon left>{{ icon }}</v-icon> {{ text }}
	</v-chip>
</template>

<script>
export default {
	name: 'InfoChip',
	props: {
		outlined: Boolean,
		icon: String,
		text: String,
	},
}
</script>